export default {
  light: {
    primary: "#2c3b92",
    secondary: "#FF5C93",
    error: "#FF4081",
    warning: "#FFC260",
    success: "#3CD4A0",
    info: "#9013FE",
    textColor: "#B9B9B9",
    iconColor: "#FFFFFF59",
    grayBold: "#4a4a4a",
  },
};
